import { Component, Input, OnInit } from '@angular/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';

@Component({
  selector: 'fa-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  notesList: any;
  @Input() showNotesOf: string[] = [];
  @Input() referenceId: string;
  @Input() truncatedNotes : boolean = false;
  constructor(
    private apiHelper: ApiHelperService,
    private gtmService: LoanGtmService
  ) { }

  ngOnInit(): void {
    this.getNotes();
  }

  async getNotes() {
    let dataParams = this.prepareParams();
    try {
      this.notesList = await this.apiHelper.getData(`notes`, {
        order: "created desc",
        where: dataParams,
        limit: 1,
        // relation users
        include: [{
          relation: "user"
        }]
      });
    } catch (error) {
      console.error(error);
    }
  }

  prepareParams() {
    let showNotes = this.gtmService.removeUndefined(this.showNotesOf);
    if (showNotes?.length > 0) {
      return {
        referenceId: this.referenceId,
        userId: { inq: showNotes }
      }
    }
  }

}
